import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import vant from 'vant'
import "vant/lib/index.css";
import { Dialog } from 'vant';
import { Overlay } from 'vant';
import { IndexBar, IndexAnchor,Cell } from 'vant';

import Vconsole from "vconsole";
let vConsole;
if (
  process.env.VUE_APP_ENV === "test" ||
  process.env.VUE_APP_ENV === "development"
) {
  vConsole = new Vconsole();
}
export default vConsole;

//css单位自适应插件
import "lib-flexible";
import VueResizeObserver from "vue-resize-observer";


import {createPinia} from "pinia";

const app = createApp(App);

// const pinia=createPinia()
// app.use(pinia)

// app.config.globalProperties.$Dialog = Dialog;
app.use(store).use(router);
app.use(VueResizeObserver);
app.use(IndexBar)
app.use(IndexAnchor)
app.use(Cell)
// app.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: "f7d40927ba4d64fb91ebe2bb9cda0995", //这里是你的高德开发者key
//   plugin: [
//     "AMap.Autocomplete",
//     "AMap.PlaceSearch",
//     "AMap.Scale",
//     "AMap.OverView",
//     "AMap.ToolBar",
//     "AMap.MapType",
//     "AMap.PolyEditor",
//     "AMap.CircleEditor",
//     "AMap.LngLat",
//     "AMap.Geocoder",
//     "MarkerClusterer",
//     "AMap.MarkerClusterer",
//   ],
//   v: "1.4.4",
//   uiVersion: "1.0.11", //UI版本号
// });
app.mount("#app");
